import type {ReasoningMessagePartComponent} from '@assistant-ui/react';
import {useMessagePartReasoning} from '@assistant-ui/react';
import Markdown from '@wandb/weave/common/components/Markdown';
import {MarkdownContainer} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/ChatView/MarkdownContainer';
import React, {memo} from 'react';

const ReasoningImpl: ReasoningMessagePartComponent = () => {
  const {text} = useMessagePartReasoning();

  return (
    <div className="text-moon-500">
      <MarkdownContainer>
        <Markdown content={text} shouldEjectFromTailwind={false} />
      </MarkdownContainer>
    </div>
  );
};

export const WBAgentReasoning = memo(
  ReasoningImpl
) as ReasoningMessagePartComponent;
WBAgentReasoning.displayName = 'WBAgentReasoning';
